import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { __decorate } from "tslib";
import { Component, Ref, Vue } from "../../../vue";
import { $methodKey } from "../../../core/stateJS/utils/consts";
import { IMethodEditorState } from "../MethodEditorState";
import styles from "./style.module.css";
import commonStyles from "../../../style/class.module.css";
let MethodInfo = class MethodInfo extends Vue {
  get rules() {
    return {
      id: [{
        required: true,
        message: '请输入方法ID',
        trigger: 'blur'
      }, {
        validator: async (_rule, value, callback) => {
          // 必须是英文
          if (!/^[a-zA-Z_][0-9a-zA-Z_]*$/.test(value)) {
            return callback('只允许输入字母、数字、下划线三种字符,不允许数字开头');
          }
          callback();
        },
        trigger: 'blur'
      }, {
        validator: async (_rule, value, callback) => {
          const isOk = this.state.checkMethodName(value, this.state.isCreateMode ? null : this.state.originMethodId);
          if (!isOk) {
            return callback('方法ID重复');
          }
          callback();
        },
        trigger: 'blur'
      }]
    };
  }
  get help() {
    var _this$state$method;
    return `使用 data.${this.state.sourceId}.$methods.${((_this$state$method = this.state.method) === null || _this$state$method === void 0 ? void 0 : _this$state$method.id) || '[方法id]'}() 调用`;
  }
  onSelectedCgiChange(value) {
    this.state.setCreateModeSelectedTpl(value);
  }
  mounted() {
    this.state.$info = this;
  }
  render() {
    const h = arguments[0];
    const {
      method,
      isCreateMode,
      methodTemplates
    } = this.state;
    if (!method) {
      return null;
    }
    return h("div", {
      "class": styles.methodInfo
    }, [h("span", {
      "class": commonStyles.label
    }, ["\u65B9\u6CD5\u4FE1\u606F"]), h("a-form-model", _mergeJSXProps([{
      "attrs": {
        "layout": "horizontal",
        "labelAlign": "left",
        "rules": this.rules
      }
    }, {
      "props": {
        model: method
      }
    }, {
      "attrs": {
        "labelCol": {
          span: 4
        },
        "wrapperCol": {
          span: 14
        }
      },
      "ref": "infoForm"
    }]), [isCreateMode ? h("a-form-model-item", {
      "attrs": {
        "label": "选择接口或模板"
      }
    }, [h("a-select", {
      "attrs": {
        "options": methodTemplates,
        "value": this.state.selectedTemplateValue
      },
      "on": {
        "change": this.onSelectedCgiChange
      }
    })]) : null, h("a-form-model-item", {
      "attrs": {
        "label": "访问路径",
        "prop": "id"
      },
      "key": "id"
    }, [h("a-input", {
      "key": "id",
      "attrs": {
        "disabled": method.system,
        "placeholder": "id",
        "addon-before": `data.${this.state.sourceId}.${$methodKey}.`
      },
      "model": {
        value: method.id,
        callback: $$v => {
          this.$set(method, "id", $$v);
        }
      }
    }, [h("a-tooltip", {
      "slot": "suffix",
      "attrs": {
        "title": this.help
      }
    }, [h("a-icon", {
      "attrs": {
        "type": "info-circle"
      },
      "style": "color: rgba(0,0,0,.45)"
    })])])]), h("a-form-model-item", {
      "attrs": {
        "label": "方法描述",
        "prop": "title"
      },
      "key": "title"
    }, [h("a-input", {
      "attrs": {
        "placeholder": "方法描述"
      },
      "key": "title",
      "model": {
        value: method.title,
        callback: $$v => {
          this.$set(method, "title", $$v);
        }
      }
    })])])]);
  }
};
__decorate([IMethodEditorState], MethodInfo.prototype, "state", void 0);
__decorate([Ref('infoForm')], MethodInfo.prototype, "form", void 0);
MethodInfo = __decorate([Component({
  name: 'MethodInfo'
})], MethodInfo);
export default MethodInfo;
//# sourceMappingURL=MethodInfo.js.map
